module.exports = __webpack_public_path__ + "static/media/comingSoonImg.3353b765.svg";